<template>
    <div class="shareExperience">
        <!-- code201跳转share-experience -->
        <div class="step_title">
            <h1>Oops!</h1>
            <div class="tip"><i class="el-icon-close"></i>We can't find your order ID ro ASIN.</div>
            <span class="border-b"></span>
            <a @click="$router.push('/findid')" style="cursor:pointer">How to find your order ID ro ASIN?</a>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    methods:{
    },
}
</script>
<style lang="less" scoped>
    .shareExperience{
        padding: 0px 30px;
        width: 70%;
        margin: 0 auto;
       .step_title{
           margin-top: 20px;
           margin-bottom: 20px;
           .tip{
                // margin-top: 20px;
                margin:20px 0px 30px 0px;
                font-size: 16px;
               i{
                    font-size: 25px;
                    color: #CC6699;
                    font-weight: bold;
                    margin-right: 5px;
                }
           }
           .border-b{
               display: block;
               width: 560px;
               height: 3px;
               background-color: #ccc;
           }
           a{
               font-size: 16px;
               line-height: 50px;
               color: #ccc;
           }
           
       }
       .post-content{
           display: flex;
           justify-content: space-around;
           margin-bottom: 30px;
           .post-content-left{
               width: 380px;
               margin-right: 4%;
               .fusion-title{
                   color: rgb(239, 129, 163);
                   font-size: 18px;
                   line-height: 26px;
                   font-weight: bold;
               }
           }
           .el-card{
              flex: 1;
           }
       }
    }
</style>